<div class="page-container">
    <div class="page-header">
        Alerts
    </div>
    <div class="container">
        <div style="display: flex; justify-content: space-between;">
            <mat-form-field class="form-field">
                <mat-label>Search</mat-label>
                <input matInput (keyup)="applyFilter($event)" placeholder="Type something..." #input>
            </mat-form-field>
            <mat-form-field appearance="legacy" class="form-field">
                <mat-label>Filter by Module</mat-label>
                <mat-select multiple [(ngModel)]="modules" (selectionChange)="onMultipleChoose($event)">
                    <mat-option [value]="'sensor'">
                        Sensor
                    </mat-option>
                    <mat-option [value]="'zone'">
                        Zone
                    </mat-option>
                    <mat-option [value]="'gateway'">
                        Gateway
                    </mat-option>
                    <mat-option [value]="'cycle'">
                        Cycle
                    </mat-option>                                 
                </mat-select>
            </mat-form-field>
            <div style="display: flex; align-items: center;">
                <mat-form-field appearance="legacy" [style.margin-right.px]="8">
                    <mat-label>Enter a date range</mat-label>
                    <mat-date-range-input [rangePicker]="picker">
                        <input matStartDate placeholder="Start date" [(ngModel)]="selectedRange.from">
                        <input matEndDate placeholder="End date" [(ngModel)]="selectedRange.to">
                    </mat-date-range-input>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                </mat-form-field>
                <button mat-flat-button [disabled]="selectedRange === undefined" color="primary"
                        (click)="fetchData()">Apply</button>

            </div>
        </div>
        <div class="table-container">
            <table mat-table [dataSource]="dataSource"
                   class="mat-elevation-z8 table"
                   matSort>

                <ng-container matColumnDef="createdAt">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [style.width.%]="10"> Start Date </th>
                    <td mat-cell *matCellDef="let element" [style.width.%]="10"> {{element?.startDate | date : 'dd.MM.yy
                        HH:mm:ss'}} </td>
                </ng-container>
                <ng-container matColumnDef="at">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [style.width.%]="10"> Last Date </th>
                    <td mat-cell *matCellDef="let element" [style.width.%]="10"> {{element?.at | date : 'dd.MM.yy
                        HH:mm:ss'}} </td>
                </ng-container>
                <ng-container matColumnDef="company">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [style.width.%]="10"> Company </th>
                    <td mat-cell *matCellDef="let element" [style.width.%]="10"> {{element?.company?.name ?
                        element?.company?.name : 'Company'}} </td>
                </ng-container>
                <ng-container matColumnDef="module">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [style.width.%]="10"> Module </th>
                    <td mat-cell *matCellDef="let element" [style.width.%]="10"> {{element?.module ?
                        element?.module : 'Module'}} </td>
                </ng-container>   
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [style.width.%]="10"> Name </th>
                    <td mat-cell *matCellDef="let element" [style.width.%]="10"> {{element?.moduleName}} </td>
                </ng-container>             
                <ng-container matColumnDef="type">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [style.width.%]="10"> Type </th>
                    <td mat-cell *matCellDef="let element" [style.width.%]="10"> {{element?.type}} </td>
                </ng-container>
                <ng-container matColumnDef="value">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [style.width.%]="5"> Value </th>
                    <td mat-cell *matCellDef="let element" [style.width.%]="5"> {{element?.value[0]}} </td>
                </ng-container>
                <ng-container matColumnDef="numEvents">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [style.width.%]="5"> Events </th>
                    <td mat-cell *matCellDef="let element" [style.width.%]="5"> {{element?.numEvents}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

                <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                    [ngClass]="row.isError ? 'error-row' : ''"
                    [@rowsAnimation]=""></tr>

                <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="4">No data matching the filter "{{input.value}}"</td>
                </tr>
            </table>
            <div class="loading-wrapper-transparent" *ngIf="loading">
                <mat-spinner diameter="30"></mat-spinner>
            </div>
        </div>
        <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="pageSize"></mat-paginator>


    </div>
</div>